import { Inject, Pipe, PipeTransform } from '@angular/core';
import { COMMONS_ENV } from '@damofire/data-angular-commons';

@Pipe({
  name: 'mobileUrlReplacer',
  standalone: true,
})
export class MobileUrlReplacer implements PipeTransform {
  constructor(@Inject(COMMONS_ENV) protected readonly environment: any) {}
  transform(value: string): string {
    if (this.environment.target === 'app') {
      return value.replace(/href='/, `/href='#`);
    }
    return value;
  }
}
